/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
import * as React from 'react';
import { IMaskInput } from 'react-imask';
import PropTypes from 'prop-types';
// import { NumericFormat } from 'react-number-format';

const CvvNumberField = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  // const onAcceptValue = (value) => {
  //   const intValue = parseInt(value, 10); // specify the radix
  //   const newValue = Number.isNaN(intValue) ? '' : Math.max(1, intValue);
  //   onChange({ target: { name, value: newValue.toString() } });
  // };

  return (
    <IMaskInput
      {...other}
      mask="0000"
      definitions={{ '#': /[0-9]/ }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

CvvNumberField.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default CvvNumberField;
